import { render } from "./ChirpCard.vue?vue&type=template&id=69211e96&ts=true"
import script from "./ChirpCard.vue?vue&type=script&lang=ts"
export * from "./ChirpCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__